import script from "./ProductGroupEdit.vue?vue&type=script&lang=ts&setup=true&name=StockList"
export * from "./ProductGroupEdit.vue?vue&type=script&lang=ts&setup=true&name=StockList"

const __exports__ = script;

export default __exports__